module.exports = function() {
  return new Worker(__webpack_public_path__ + "5e41af3026588fb63b62.worker.js");
};